/**
 * @generated SignedSource<<9d34efd873f994e14624274e04170f1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type loginOkta_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly " $fragmentType": "loginOkta_viewer";
};
export type loginOkta_viewer$key = {
  readonly " $data"?: loginOkta_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"loginOkta_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "loginOkta_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "061530426c9bfb9e974c887858af1d7f";

export default node;
